import { render, staticRenderFns } from "./QualityReportList.vue?vue&type=template&id=5a5f2928&scoped=true&"
import script from "./QualityReportList.vue?vue&type=script&lang=js&"
export * from "./QualityReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5f2928",
  null
  
)

export default component.exports